module.exports = __webpack_public_path__ + "img/凯儿得乐新logo-02@2x.50bce419.png";